// Hero Builder Font Categories and Utilities

export const FONT_CATEGORIES = [
  {
    name: 'Editorial Serif',
    fonts: ['Cormorant Garamond', 'EB Garamond', 'Crimson Pro', 'Libre Baskerville', 'Spectral', 'Lora']
  },
  {
    name: 'Victorian / Historical',
    fonts: ['Cinzel', 'Cinzel Decorative', 'Playfair Display', 'Old Standard TT', 'Cardo']
  },
  {
    name: 'Vintage Newspaper',
    fonts: ['Marcellus', 'Bellefair', 'Italiana']
  },
  {
    name: 'Book & Publishing',
    fonts: ['Merriweather', 'Gentium Book Plus', 'Alegreya']
  },
  {
    name: 'Elegant Calligraphy',
    fonts: ['Great Vibes', 'Allura', 'Tangerine', 'Satisfy']
  },
  {
    name: 'Handwritten Letter',
    fonts: ['Dancing Script', 'Caveat', 'Kalam']
  },
  {
    name: 'Typewriter',
    fonts: ['Special Elite', 'Courier Prime', 'Cutive Mono']
  },
  {
    name: 'Old Post Office / Postal',
    fonts: ['IM Fell English', 'IM Fell DW Pica']
  },
  {
    name: 'Storybook',
    fonts: ['Fondamento', 'MedievalSharp', 'UnifrakturMaguntia']
  },
  {
    name: "Children's Storybook",
    fonts: ['Patrick Hand', 'Baloo 2', 'Bubblegum Sans']
  }
];

export const ALL_FONT_FAMILIES = FONT_CATEGORIES.flatMap(c => c.fonts);

export const buildGoogleFontsUrl = (families) => {
  const params = families
    .map(f => `family=${f.replace(/ /g, '+')}:wght@300;400;500;600;700`)
    .join('&');
  return `https://fonts.googleapis.com/css2?${params}&display=swap`;
};

export const loadHeroFonts = (families) => {
  if (!families || !families.length) return;
  const id = 'hero-builder-fonts';
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }
  link.href = buildGoogleFontsUrl(families);
};

export const loadAllHeroFonts = () => loadHeroFonts(ALL_FONT_FAMILIES);

export const TEXT_SHADOW_PRESETS = [
  { name: 'None', value: 'none' },
  { name: 'Soft Gold Glow', value: '0 0 6px rgba(212,184,118,0.5), 0 0 18px rgba(200,162,74,0.3), 0 0 40px rgba(196,168,118,0.15), 0 2px 4px rgba(0,0,0,0.4)' },
  { name: 'Warm Glow', value: '0 0 8px rgba(212,184,118,0.3), 0 1px 4px rgba(0,0,0,0.5)' },
  { name: 'Subtle Dark', value: '0 1px 3px rgba(0,0,0,0.5)' },
  { name: 'Strong Dark', value: '0 2px 8px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.4)' },
  { name: 'Crisp Light', value: '0 0 10px rgba(255,255,255,0.3), 0 1px 3px rgba(0,0,0,0.3)' },
];

export const COLOR_PRESETS = [
  { name: 'Gold', value: '#D4B876' },
  { name: 'Light Gold', value: '#D4BA8A' },
  { name: 'Warm Gold', value: '#C4A876' },
  { name: 'Deep Gold', value: '#B09060' },
  { name: 'Dark Brown', value: '#2D2926' },
  { name: 'Warm Brown', value: '#5C4A3D' },
  { name: 'Parchment', value: '#FAF7F2' },
  { name: 'Ivory', value: '#F5EFE6' },
  { name: 'White', value: '#FFFFFF' },
  { name: 'Black', value: '#000000' },
  { name: 'Gold 80%', value: 'rgba(212,184,118,0.8)' },
  { name: 'Gold 60%', value: 'rgba(212,184,118,0.6)' },
];

export const DEFAULT_HERO_SETTINGS = {
  height_desktop: '100vh',
  height_tablet: '80vh',
  height_mobile: '70vh',
  background_image: '',
  background_video: '',
  background_parallax: false,
  background_overlay_color: '#000000',
  background_overlay_opacity: 30,
  background_blur: 0,
  background_position: 'center center',
};
